<template>
  <el-dialog class="user_model_dialog" top="5vh" center :title="newTitle" :append-to-body="true" width="70%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;">
        <el-form-item  label="体系名称" prop="nameZh" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.nameZh" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="体系简称" prop="nameEn" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.nameEn" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width:30%;">
          <el-switch v-model="form.status" active-color="#11a983" inactive-color="#f5f7fa" active-value="1" inactive-value="0" :disabled="!isEditOrCreate">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否客户联调" prop="isJointCommissioning" :label-width="formLabelWidth" style="width:30%;">
          <el-switch v-model="form.isJointCommissioning" active-color="#11a983" inactive-color="#f5f7fa" :active-value="1" :inactive-value="0" :disabled="!isEditOrCreate">
          </el-switch>
        </el-form-item>
      </div>
      <el-form-item label="项目负责人" prop="ownerIds" :label-width="formLabelWidth" label-position="left">
        <el-select  filterable  clearable multiple size="mini" v-model="form.ownerIds"  placeholder="请选择人员" :disabled="!isEdit"  style="width: 80%">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="技术负责人" prop="reviewerds" :label-width="formLabelWidth" label-position="left">
        <el-select  filterable  clearable multiple size="mini" v-model="form.reviewerds"  placeholder="请选择人员" :disabled="!isEdit"  style="width: 80%">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="isEdit" :loading="loading.submit" type="primary"  @click="onSubmit">保存</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  getDevOpsSpaceSystemDetailApi,
  getDevOpsSpaceTeamDetaililApi,
  postDevOpsSpaceAddSystemApi,
  postDevOpsSpaceUpdateSystemApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    isEdit:{
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        nameZh: '',
        nameEn: '',
        status: '1',
        isJointCommissioning:0,
        ownerIds: [],
        reviewerds:[],
      },
      rules: {
        nameZh: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        nameEn: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        status: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        isJointCommissioning: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        ownerIds: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reviewerds: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
      },
      allRoles: [],
      allUser:[],
    };
  },
  async mounted() {
    const { id = ''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
    this.form = { ...this.form, id}
    this.$set(this.form, 'username', username)
    this.username = username;
    this.$nextTick(async () => {
      await this.getDevOpsSpaceAllUser();
      if(id) await this.init(id)
      if(!id && userId){
        this.form.ownerIds = [userId.toString()];
      }
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    // 部分不可编辑
    isProjectDisabled() {
      return true;
    },
    isEditOrCreate(){
      if(!this.form.id){
        return false;
      }
      if(this.isEdit){
        return this.isEdit;
      }

      return false;
    },
    newTitle() {
      if (this.form.id) {
        return '编辑体系';
      } else {
        return '新增体系'
      }
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeSwitch(v){
      console.log(v);
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    // 获取详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceSystemDetailApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          status: info.status.toString(),
          ownerIds: info.ownerIds ? info.ownerIds.split(',') : [],
          reviewerds: info.reviewerds ? info.reviewerds.split(',') : [],
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          nameZh = "",
          nameEn = '',
          ownerIds = [],
          reviewerds = [],
          status = '',
          id = '',
          isJointCommissioning=0,
        } = this.form;
        const param = { isJointCommissioning,nameZh,ownerIds:ownerIds.toString(), reviewerds:reviewerds.toString(),nameEn, status ,id};
        // id 存在 更新 不存在 创建
        const ret = this.form.id ? await postDevOpsSpaceUpdateSystemApi({ ...param, id: this.form.id || "" }) : await postDevOpsSpaceAddSystemApi(param);
        if (ret.status === 'success') {
            this.$notify({
              message: ret.message || '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.user_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
